<template>
  <BaseTable :name='name' :getDataAction='getDataAction' :tableColumns='tableColumns' :isShowCloseBtn='isShowCloseBtn' @SizeChange='sizeChange' @StateChange='stateChange'></BaseTable>
</template>


<script>
import {
  GetOverduePurchaseOrders
} from '@/api'
import BaseTable from './../baseTable.vue'

export default ({
  // mixins: [BaseReportMixin],
  components: {
    BaseTable
  },
  data () {
    return {
      getDataAction: GetOverduePurchaseOrders,
      tableColumns: [
        {
          no: 'no',
          name: '单号',
          width: 120,
          type: 'text',
        },
        {
          no: 'supplierName',
          name: '供应商',
          width: 100,
          type: 'text',
        },
        {
          no: 'days',
          name: '逾期天数',
          width: 60,
          type: 'text',
        },
        {
          no: 'status',
          name: '完成情况',
          width: 80,
          type: 'progress',
          number: 'finishNumber',
          totalNumber: 'orderNumber'
        },

      ],
      // myChart: null,
      // option: {},
      // tableData: [],
      // allData: [],
      // show: true,
      // totalPage: 0,
      // pageSize: 5,
      // pageIndex: 1,
      // interval: 5 * 1000,
      // setInterval: null
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
  },
  methods: {

    sizeChange (a, b, c, d) {
      this.$emit('SizeChange', a, b, c, d)
    },
    stateChange (a, b) {
      this.$emit('StateChange', a, b)
    },
  },
  mounted () {
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
  },
  beforeDestroy () {
    // clearInterval(this.setInterval)
  },
})
</script>
<style scoped lang="scss">
</style>
